import PATH from "constants/path";
import React from "react";
import { Point1, Point2, Point3, Point4, ChevronRight } from "assets/svg";
import { illust03, illust201 } from "assets/img";
import { isAuthenticated } from "utils/common";

function AboutPoint() {
  return (
    <div className={isAuthenticated() ? "w-80" : "itsumoni container px-0"}>
      <div className="bg-green text-white py-2 text-center position-relative sp-1 fw-600">
        <div className="fs-12 lh-21">＼モニター体験でポイントゲット!／</div>
        <div className="fs-20 fs-sm-18">ポイントについて</div>
        <img
          className="position-absolute top-100 top-sm-75 end-0 translate-middle-y img-w mb-sm-0"
          src={illust03}
          alt={illust03}
        ></img>
      </div>

      <div className="py-3 px-4 px-md-0 bg-brown">
        <div className="w-icon-point d-flex justify-content-between">
          <div className="d-flex flex-column text-center">
            <div>
              <Point1 className="img-icon-point" />
            </div>
            <div className="fs-16 fs-sm-10 fw-500 fw-sm-400 mt-2 mt-md-3">
              謝礼はポイント制 <br />
              (1ポイント＝1円)
            </div>
          </div>
          <div className="d-flex flex-column text-center">
            <div>
              <Point2 className="img-icon-point" />
            </div>
            <div className="fs-16 fs-sm-10 fw-500 fw-sm-400 mt-2 mt-md-3">
              月末1,000ポイント 以上 <br />
              の累積でお支払い
            </div>
          </div>
          <div className="d-flex flex-column text-center">
            <div>
              <Point3 className="img-icon-point" />
            </div>
            <div className="fs-16 fs-sm-10 fw-500 fw-sm-400 mt-2 mt-md-3">
              月末締めの翌月 <br />
              15日払い
            </div>
          </div>
        </div>
      </div>

      <div className="my-0 my-md-4 p-3 p-lg-0">
        <div className="clearfix d-flex flex-wrap d-md-block">
          <div className="ms-0 ms-md-3 img-point float-md-end order-2 text-center">
            <img src={illust201} alt="illust201"></img>
          </div>
          <div className="order-1">
            <div className="ps-0 ps-lg-2 fs-20 fs-sm-14 sp-14 fw-500">
              <span className="fs-28 text-green"> 1 </span>
              ポイント＝
              <span className="fs-28 text-green"> 1 </span>
              円として換算いたします。
            </div>

            <div className="my-3 sp-14 fw-500">
              ※ご登録者本人以外の参加や回答、不正参加や不完全な回答などがあった場合は、謝礼のポイントは付与されません。
            </div>
          </div>
          <div className="my-3 d-flex order-3 text-red-light fw-bolder word-break-normal">
            <span className="me-2">
              <i className="bi bi-exclamation-triangle-fill"></i>
            </span>
            ポイントは、アーキテクト会員サイトの各サービス(いつモニ、CLAP&WALK、am!)ごとにそれぞれ付与され管理されますのでご注意ください。
          </div>
        </div>
      </div>

      <div className="my-0 my-md-3 p-3 p-lg-0 sp-14 fw-400">
        <div className="clearfix d-flex flex-wrap d-md-block">
          <div className="ms-0 ms-md-4 my-3 content-point float-md-end order-2">
            <div className="position-absolute top-0 start-0 translate-middle-y fs-16 bg-green text-white py-1 px-4 border-radius-5">
              例えば
            </div>
            <div className="mt-2">
              累計850ポイントの場合、さらに150ポイント以上獲得すると、謝礼がお振込されます。
            </div>
            <div className="text-center mt-2">
              <Point4 />
            </div>
          </div>

          <div className="order-1 mb-5 mb-md-0">
            <div className="text-green fs-18 fs-sm-16 fw-600">
              お振込について
            </div>
            <div className="mt-2 sp-14">
              ポイントの合計が月末時点で1,000ポイントを超えると、翌月15日（銀行が休業日の際は翌営業日）に自動的にご登録いただいた銀行口座へお振込します。ポイントの合計が1,000ポイントに達していない場合、銀行口座のご登録がない場合は、翌月以降に謝礼ポイントが繰越されます。謝礼ポイントの有効期限は、付与されてから1年間となります。
            </div>
          </div>
        </div>

        <div className="my-3">
          <div className="text-green fs-18 fs-sm-16 fw-600">
            金融機関について
          </div>
          <div className="mt-2 sp-14">
            銀行口座は、都市銀行、地方銀行、ゆうちょ銀行、ネット銀行など、あらゆる金融機関の口座が登録できます。
            <br />
            ただし、
            <span className="text-red-light fw-600">
              ゆうちょ銀行と楽天銀行以外
            </span>
            の金融機関は、
            <span className="text-red-light fw-600">取扱事務手数料200円</span>
            を差し引いてお振込みさせていただきます。
          </div>
        </div>
      </div>

      <div className="text-grey fs-14 fs-sm-12 fw-600 mt-lg-5">
        <div className="text-center mt-3 mt-md-2">
          <a href={PATH.FIRST}>
            はじめての方へ
            <span className="ms-2">
              <ChevronRight />
            </span>
          </a>
        </div>
        <div className="text-center mt-3 mt-md-2">
          <a href={PATH.GUIDE}>
            ご利用方法
            <span className="ms-2">
              <ChevronRight />
            </span>
          </a>
        </div>
        <div className="text-center mt-3 mt-md-2">
          <a href={PATH.QUESTIONS}>
            よくあるご質問
            <span className="ms-2">
              <ChevronRight />
            </span>
          </a>
        </div>
      </div>
    </div>
  );
}

export default AboutPoint;
